import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { StatusDocumentoEnum } from '../../../../shared/enums/dfe/status-documento.enum';
import { DetalheNFeEmitidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-nfe-emitido.response';
import { DetalheNFCeEmitidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-nfce-emitido.response';
import { ProdutoDocumentoFiscalStruct } from '../../../../shared/services/structs/repo-dfe/produto-documento-fiscal.struct';

@Component({
    selector: 'app-nfe-detalhe-emitido',
    standalone: true,
    imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatTableModule, CurrencyPipe, DatePipe, LoadingBoxComponent, NgxMaskPipe],
    providers: [provideNgxMask()],
    templateUrl: './nfe-detalhe-emitido.component.html',
    styleUrls: ['./nfe-detalhe-emitido.component.css']
})
export class NFeDetalheEmitidoComponent implements OnInit {
    @Input() notaDetalhe!: DetalheNFeEmitidoResponse | DetalheNFCeEmitidoResponse;
    @Input() nomeModeloDocumento = 'NF-e';

    public readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };
    public _isLoading = true;
    public _isCancelamento = false;
    public displayedColumnsProdutos: string[] = ['numero', 'codigo', 'descricao', 'valorTotal', 'cfop', 'gtin', 'ncm'];
    public dataSourceProdutos = new MatTableDataSource<ProdutoDocumentoFiscalStruct>();

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.dataSourceProdutos.data = this.notaDetalhe.produtos;
        this._isCancelamento = this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Cancelado;
        this._isLoading = false;
    }

    public get isDocumentoResumido(): boolean {
        return this.notaDetalhe.isDocumentoResumido;
    }

    public obterDescricaoSituacaoDocumento(): string {
        if (this._isCancelamento) return 'Cancelado';
        return this.notaDetalhe.resumo.descricaoSituacaoDocumento || 'Autorizado';
    }

    public voltar(): void {
        this.router.navigate(['/notas-fiscais/painel-contador/']);
    }
}
